import React from 'react';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { useFormattedDuration } from 'modules/notes/common/components/Timer/useFormattedDuration';

const useStyles = makeStyles((theme) => ({
  valuesTypography: {
    fontWeight: theme.typography.fontWeightMedium
  }
}));
type TimeFormatComponentProps = {
  duration: number;
};
const TimeFormatComponent: React.FC<TimeFormatComponentProps> = ({
  duration
}: TimeFormatComponentProps) => {
  const classes = useStyles();

  const formattedDuration = useFormattedDuration({
    needsMask: true,
    duration: duration ?? 0
  });
  return (
    <Typography
      variant="body1"
      className={classes.valuesTypography}
      data-testid={'source-by-time-chart-formatted-time'}
    >
      {formattedDuration}
    </Typography>
  );
};

export default React.memo(TimeFormatComponent);
